import ToastEventBus from 'primevue/toasteventbus'

// Inside the native mobile webview the in-page PrimeVue toasts look out of place, so route
// them to the native app (which renders its own toast) and skip the in-page one. Falls back
// to the normal toast when no native toast bridge is available (browser, or apps without it).
const addToast = (message = {}) => {
  if (window.AndroidBridge && typeof window.AndroidBridge.showToast === 'function') {
    try {
      const text = [message.summary, message.detail].filter(Boolean).join(': ')
      window.AndroidBridge.showToast(text, message.severity || 'info')
      return
    } catch (err) {
      console.error('Native toast failed, falling back to in-page toast:', err)
    }
  }
  ToastEventBus.emit('add', message)
}

export default {
  install (app) {
    app.config.globalProperties.$toast = {
      add: addToast,
      removeAllGroups: () => ToastEventBus.emit('remove-all-groups')
    }
  }
}
